// src/assets/js/analytics.js

window.dataLayer = window.dataLayer || [];

export function gtag() {
  window.dataLayer.push(arguments);
}
